import {
    SeonSession,
    SessionStorageService,
} from '@core/services/antiFraud/types';

const key = 'antifraud:session';
const sessionIdKey = 'antifraud:sessionId';

export const sessionStorageService: SessionStorageService = {
    clear(): void {
        localStorage.removeItem(key);
        localStorage.removeItem(sessionIdKey);
    },
    exists(): boolean {
        return !!localStorage.getItem(key) && !!localStorage.getItem(sessionIdKey);
    },
    get(): SeonSession {
        return localStorage.getItem(key) as SeonSession;
    },
    getId(): string {
        return localStorage.getItem(sessionIdKey) as string;
    },
    set(session: SeonSession): void {
        localStorage.setItem(key, session);
    },
    setId(sessionId: string): void {
        localStorage.setItem(sessionIdKey, sessionId);
    },
};
